// src/pages/reports/DmsUploadReport.js
import React, { useEffect, useState, useMemo } from "react";
import Layout from "../../components/Layout";
import { db } from "../../firebase";
import {
  collection,
  query,
  where,
  getDocs,
  Timestamp,
} from "firebase/firestore";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function toStartOfDayTs(d) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return Timestamp.fromDate(x);
}
function toEndOfDayTs(d) {
  const x = new Date(d);
  x.setHours(23, 59, 59, 999);
  return Timestamp.fromDate(x);
}
function formatDDMMYYYY(ts) {
  return ts.toDate().toLocaleDateString("en-IN");
}

export default function DmsUploadReport() {
  const today = new Date().toISOString().slice(0, 10);
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [partyFilter, setPartyFilter] = useState("");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadReport = async () => {
    try {
      setLoading(true);

      let q = query(
        collection(db, "orderLines"),
        where("status", "==", "APPROVED"),
        where("approvedAt", ">=", toStartOfDayTs(fromDate)),
        where("approvedAt", "<=", toEndOfDayTs(toDate))
      );

      const snap = await getDocs(q);
      const map = new Map();

      snap.forEach((doc) => {
        const r = doc.data();
        if (partyFilter && r.partyName !== partyFilter) return;

        const date = formatDDMMYYYY(r.approvedAt);
        const key = `${date}__${r.dmsName}__${r.msku}`;

        if (!map.has(key)) {
          map.set(key, {
            Date: date,
            DMSName: r.dmsName || "",
            MSKU: r.msku || "",
            Qty: 0,
          });
        }
        map.get(key).Qty += Number(r.qty || 0);
      });

      setRows(Array.from(map.values()));
    } catch (e) {
      console.error(e);
      alert("Failed to load DMS Upload Report");
    } finally {
      setLoading(false);
    }
  };

  const exportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "DMS");
    const out = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([out]), `DMS_Upload_${fromDate}_to_${toDate}.xlsx`);
  };

  return (
    <Layout>
      <div style={{ padding: 20 }}>
        <h2>DMS Upload Report</h2>

        <input type="date" value={fromDate} onChange={(e)=>setFromDate(e.target.value)} />
        <input type="date" value={toDate} onChange={(e)=>setToDate(e.target.value)} />
        <input placeholder="Party Name (optional)" onChange={(e)=>setPartyFilter(e.target.value)} />

        <button onClick={loadReport}>Load</button>
        <button onClick={exportExcel}>Export</button>

        {loading ? "Loading..." : (
          <table border="1" cellPadding="6">
            <thead>
              <tr>
                <th>Date</th>
                <th>DMS Name</th>
                <th>MSKU</th>
                <th>Qty</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r,i)=>(
                <tr key={i}>
                  <td>{r.Date}</td>
                  <td>{r.DMSName}</td>
                  <td>{r.MSKU}</td>
                  <td>{r.Qty}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </Layout>
  );
}
